import { render, staticRenderFns } from "./mNews.vue?vue&type=template&id=51d62485&scoped=true&"
import script from "./mNews.vue?vue&type=script&lang=js&"
export * from "./mNews.vue?vue&type=script&lang=js&"
import style0 from "./mNews.vue?vue&type=style&index=0&id=51d62485&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d62485",
  null
  
)

export default component.exports